// KOREA
const backServer = "http://admin.kr.edenlx.com:8081";

// JAPAN
 //const backServer = "http://admin.jp.edenlx.com:8081";

// TAIWAN
 export const backServerTw = "http://admin.tw.edenlx.com:8081";

// // China
 //const backServer = "http://edenlux.id.sd.cn:8081";

//USA
//  const backServer = "http://admin.us.edenlx.com:8081";

export const title = `${"한국"} 관리자페이지`
//export const title = `${"일본"} 관리자페이지`
// export const title = `${"대만(홍콩)"} 관리자페이지`
// export const title = `${"중국"} 관리자페이지`
// export const title = `${"US"} 관리자페이지`

export default backServer;